import { render, staticRenderFns } from "./PromotionPaymentCondition.vue?vue&type=template&id=4bff5a28&scoped=true&"
import script from "./PromotionPaymentCondition.vue?vue&type=script&lang=js&"
export * from "./PromotionPaymentCondition.vue?vue&type=script&lang=js&"
import style0 from "./PromotionPaymentCondition.vue?vue&type=style&index=0&id=4bff5a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bff5a28",
  null
  
)

export default component.exports